/** Ortak yükleme/hata durumu bileşenleri. */
import type { ReactNode } from 'react';
import { BrandMark } from './BrandMark.tsx';

export function Loading({ label = 'Yükleniyor…' }: { label?: string }): ReactNode {
  return (
    <p className="state state--loading" role="status">
      <BrandMark size={18} pulse />
      <span>{label}</span>
    </p>
  );
}

export function ErrorNotice({
  message,
  onRetry,
  retryLabel = 'Tekrar dene',
}: {
  message: string;
  onRetry?: (() => void) | undefined;
  retryLabel?: string;
}): ReactNode {
  return (
    <div className="state state--error" role="alert">
      <p className="state__message">{message}</p>
      {onRetry !== undefined && (
        <button type="button" className="button button--ghost state__action" onClick={onRetry}>
          {retryLabel}
        </button>
      )}
    </div>
  );
}

export function Empty({ message }: { message: string }): ReactNode {
  return <p className="state state--empty">{message}</p>;
}
